import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticatedSelector } from 'Store/modules/auth/selectors';
import { routes } from 'Constants/routes';
import { PublicRouteProps } from './types';

const PublicRoute = ({ component: Component, ...rest }: PublicRouteProps): JSX.Element => {
  const isAuthenticated = useSelector(isAuthenticatedSelector);
  if (isAuthenticated) {
    return <Redirect to={routes.DASHBOARD} />;
  }
  return <Route {...rest} exact render={props => <Component {...rest} {...props} />} />;
};

PublicRoute.defaultProps = {
  component: null,
  partner: null,
};

export default PublicRoute;
